import { render } from "./AddCurrency.vue?vue&type=template&id=00b3c20a"
import script from "./AddCurrency.vue?vue&type=script&lang=js"
export * from "./AddCurrency.vue?vue&type=script&lang=js"

import "./AddCurrency.vue?vue&type=style&index=0&id=00b3c20a&lang=scss"

import exportComponent from "/home/douglas/Documents/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__